<ng-container>
  <equity-sub-asset-filter *ngIf="selectedFilterByName === fd3filtersList.equity"></equity-sub-asset-filter>
  <fixed-income-sub-asset-filter *ngIf="selectedFilterByName === fd3filtersList.fixedIncome"></fixed-income-sub-asset-filter>
  <multi-asset-sub-asset-filter *ngIf="selectedFilterByName === fd3filtersList.multiAsset"></multi-asset-sub-asset-filter>
  <cash-equivalent-sub-asset-filter *ngIf="selectedFilterByName === fd3filtersList.cashEquivalent"></cash-equivalent-sub-asset-filter>
</ng-container>


